// Slogan.js
import React, { useEffect, useRef } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const BlinkingText = () => {
  const sloganRef = useRef(null);
  const { t } = useLanguage();

  useEffect(() => {
    // Ajoute la classe "show" une fois le composant monté
    if (sloganRef.current) {
      sloganRef.current.classList.add('show');
    }
  }, []);

  // Récupérer le slogan traduit
  const slogan = t('slogan.main');
  
  // Diviser le slogan en deux parties au niveau de la virgule
  const parts = slogan.split(',');
  const firstPart = parts[0] ? parts[0] + ',' : '';
  const secondPart = parts[1] ? parts[1].trim() : '';

  return (
    <div className="blinkingText-Wrapper" ref={sloganRef}>
      <p className="blinking-text">
        {firstPart.split('').map((letter, index) => (
          <span key={index} data-letter={letter}>{letter}</span>
        ))}
      </p>
      {secondPart && (
        <p className="blinking-text2">
          {secondPart.split('').map((letter, index) => (
            <span key={index} data-letter={letter}>{letter}</span>
          ))}
        </p>
      )}
    </div>
  );
};

export default BlinkingText;

